"use client"

import { useState, useEffect } from "react"
import {
  deleteAcademy,
  fetchAcademyData,
  verifyAcademy,
} from "../comman/Academy.js";
import Sidebar from "../components/Sidebar.js";
import { FaEdit, FaTrash, FaCheckCircle } from "react-icons/fa"
import { IoMdAdd, IoMdSearch } from "react-icons/io"
import AddAcademyModal from "../components/AddAcademyModal.js";

const AcademyDetails = () => {
  const [academies, setAcademies] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [searchQuery, setSearchQuery] = useState("")
  const [selectedAcademy, setSelectedAcademy] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const fetchAcademy = async () => {
    try {
      setLoading(true)
      const data = await fetchAcademyData()
      setAcademies(data)
    } catch (err) {
      setError("No Accademy Found")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAcademy()
  }, []) //Fixed: Added empty dependency array to run only once on mount

  const handleVerify = async (academyId, index, currentStatus) => {
    try {
      await verifyAcademy(academyId, !currentStatus)
      setAcademies((prevAcademies) =>
        prevAcademies.map((academy, idx) => (idx === index ? { ...academy, verify: !currentStatus } : academy)),
      )
    } catch (error) {
      console.error("Error updating verification status:", error)
    }
  }

  const handleAddAcademy = () => {
    setSelectedAcademy(null)
    setIsModalOpen(true)
  }

  const handleEditAcademy = (academy) => {
    setSelectedAcademy(academy)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => setIsModalOpen(false)

  const handleSubmitAcademy = async (formData) => {
    await fetchAcademy()
    setIsModalOpen(false)
  }

  const handleDeleteAcademy = async (academyId) => {
    if (window.confirm("Are you sure you want to delete this academy?")) {
      await deleteAcademy(academyId)
      setAcademies(academies.filter((academy) => academy._id !== academyId))
    }
  }

  const filteredAcademies = academies.filter(
    (academy) =>
      academy?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      academy?.owner?.email?.toLowerCase().includes(searchQuery.toLowerCase()),
  )

  return (
    <div className="flex min-h-screen bg-gray-100 overflow-hidden">
      <Sidebar />
      <div className="flex-1 p-6 overflow-auto ml-0 sm:ml-64 transition-all duration-300 ease-in-out">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Academy Management</h1>
        <div className="flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
          <div className="relative w-full sm:w-auto">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <IoMdSearch className="w-5 h-5 text-gray-500" />
            </div>
            <input
              type="text"
              className="block w-full sm:w-64 p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary focus:border-primary"
              placeholder="Search academies"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <button
            onClick={handleAddAcademy}
            className="flex items-center bg-primary text-white px-4 py-2 rounded-md hover:bg-opacity-90 transition duration-300"
          >
            <IoMdAdd size={20} className="mr-2" />
            Add Academy
          </button>
        </div>
        {loading ? (
          <p className="text-center text-gray-600">Loading academies...</p>
        ) : error ? (
          <p className="text-center text-gray-900">No Academy Found!</p>
        ) : (
          <div className="overflow-x-auto shadow-md sm:rounded-lg max-w-full">
            <table className="w-full text-sm text-left text-gray-500 table-auto">
              <thead className="text-xs text-white uppercase bg-primary">
                <tr>
                  {[
                    "Academy Name",
                    "Academy Owner",
                    "Address",
                    "Location Pin",
                    "Timings",
                    "Sports",
                    "Available Days",
                    "Pricing",
                    "Verify",
                    "Actions",
                  ].map((heading) => (
                    <th key={heading} className="px-2 py-3 sm:px-6">
                      {heading}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredAcademies.length > 0 ? (
                  filteredAcademies.map((academy, index) => (
                    <tr
                      key={academy._id}
                      className={`border-b hover:bg-gray-50 ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
                    >
                      <td className="px-2 py-4 sm:px-6 text-gray-900">{academy?.name || "N/A"}</td>
                      <td className="px-2 py-4 sm:px-6 text-gray-900">{academy?.owner?.email || "N/A"}</td>
                      <td className="px-2 py-4 sm:px-6 text-gray-900">{academy?.address || "N/A"}</td>
                      <td className="px-2 py-4 sm:px-6 text-gray-900">{academy?.locationPin || "N/A"}</td>
                      <td className="px-2 py-4 sm:px-6 text-gray-900">{academy?.timings || "N/A"}</td>
                      <td className="px-2 py-4 sm:px-6 text-gray-900">
                        {academy?.sports?.length ? academy.sports.join(", ") : "N/A"}
                      </td>
                      <td className="px-2 py-4 sm:px-6 text-gray-900">
                        {academy?.availableDays?.length ? academy.availableDays.join(", ") : "N/A"}
                      </td>
                      <td className="px-2 py-4 sm:px-6 text-gray-900">{academy?.pricing || "N/A"}</td>
                      <td className="px-6 py-4">
  {academy.verify ? (
    <div className="flex items-center text-green-600">
      <FaCheckCircle className="w-4 h-4 mr-1.5" />
      <span className="font-medium">Verified</span>
    </div>
  ) : (
    <button
      className="px-4 py-1.5 bg-[#12143F] text-white rounded-md transition-all hover:bg-opacity-90 text-sm font-medium flex items-center"
      onClick={() => handleVerify(academy._id, index, academy.verify)}
    >
      <FaCheckCircle className="w-4 h-4 mr-1.5" />
      Verify Now
    </button>
  )}
</td>

                      <td className="px-2 py-4 sm:px-6 flex space-x-2">
                        <button
                          onClick={() => handleEditAcademy(academy)}
                          className="text-primary hover:text-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                          aria-label="Edit academy"
                        >
                          <FaEdit size={18} />
                        </button>
                        <button
                          onClick={() => handleDeleteAcademy(academy._id)}
                          className="text-red-500 hover:text-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                          aria-label="Delete academy"
                        >
                          <FaTrash size={18} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="px-2 py-4 sm:px-6 text-center text-gray-900">
                      No academies found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <AddAcademyModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitAcademy}
        academyData={selectedAcademy}
      />
    </div>
  )
}

export default AcademyDetails

